// src/scripts/ProtectedRoute.jsx - PATCHED
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useUser } from '../contexts/UserContext';
import LoadingScreen from '../components/common/LoadingScreen.jsx';

export const ProtectedRoute = ({ children }) => {
  // Destructure both user and the loading state from UserContext
  // Assuming UserContext exposes its loading state as 'loading'
  const { user, loading: userLoading } = useUser(); 
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only attempt to redirect if userLoading is false (meaning auth state is determined)
    // and if there's definitively no user.
    if (!userLoading && !user) {
      // Avoid redirecting if already on login or auth callback paths
      if (!location.pathname.startsWith('/login') && !location.pathname.startsWith('/auth/callback')) {
        console.log('[ProtectedRoute] User not authenticated and not loading, redirecting to login from:', location.pathname);
        navigate('/login', { replace: true, state: { from: location } });
      }
    }
  }, [user, userLoading, navigate, location]); // Add userLoading to dependencies

  // If user authentication state is still loading, show a loading screen.
  if (userLoading) {
    // It's important that UserContext correctly manages its 'loading' state
    // to be 'true' during initial auth check and any re-authentication process.
    return <LoadingScreen type="default" message="Vérification de l'authentification..." />;
  }

  // If loading is complete and there's a user, render the children.
  // If loading is complete and there's no user, the useEffect will handle redirection.
  // Returning null here while waiting for redirect prevents rendering children prematurely.
  return user ? children : null; 
  // Alternatively, if you want to show a loading screen even during the brief moment
  // before redirection by useEffect, you could do:
  // return user ? children : <LoadingScreen type="default" message="Redirection..." />;
  // But `null` is often fine as the redirect should be quick.
};